export default {
  objectToFormData(obj, form, namespace){
      const fd = form || new FormData();
      let formKey;

      for(var property in obj) {
          if(obj.hasOwnProperty(property)) {
            let key = Array.isArray(obj) ? '[]' : `[${property}]`;
            if(namespace) {
              formKey = namespace + key;
            } else {
              formKey = property;
            }

            // if the property is an object, but not a File, use recursivity.
            if(typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
              objectToFormData(obj[property], fd, formKey);
            } else {

              // if it's a string or a File object
              fd.append(formKey, obj[property]);
            }

          }
        }
      return fd;

  },
  toPageStyle(bgstyle){
  	let style = {}
  	style= bgstyle
  	let gradient = bgstyle.gradient.map(item=>{
  	  if(item.color){
  	    return `${item.color} ${item.percent}%`
  	  }
  	  return ''
  	})
  	for(let i=gradient.length-1;i>=0;--i){
  	  if(!gradient[i]){
  	    gradient.splice(i,1)
  	  }
  	}
  	if(gradient.length < 2){
  	  return style
  	}
  	style.backgroundImage = `linear-gradient(${gradient.join()})`
    delete style.gradient
  	return style
  },
}



// WEBPACK FOOTER //
// ./src/assets/common.js